import { InteractiveContainer, PlainButton } from "@jugl-web/ui-components";
import React, { PropsWithChildren } from "react";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";

export const AgentKnowledgeItemContainer: React.FC<
  PropsWithChildren<{
    icon: React.ReactNode;
    title: string;
    onDelete?: () => void;
    onClick: () => void;
  }>
> = ({ icon, title, onDelete, onClick, children }) => (
  <InteractiveContainer
    className="border-grey-400 flex items-start justify-between gap-2.5 rounded-2xl border border-solid p-5"
    onClick={onClick}
  >
    <div className="flex flex-col gap-1.5 overflow-hidden">
      <div className="flex items-center gap-1.5">
        <div className="flex shrink-0 items-center justify-center">{icon}</div>
        <span className="text-dark font-secondary truncate font-semibold leading-4">
          {title}
        </span>
      </div>
      <div className="text-dark-700 font-secondary line-clamp-5 jugl__break-word max-w-[700px] text-sm">
        {children}
      </div>
    </div>
    {onDelete && (
      <PlainButton
        className="flex shrink-0 items-center justify-center p-1.5"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <TrashIcon />
      </PlainButton>
    )}
  </InteractiveContainer>
);
